import React from "react";
import type { Training } from "../../../../api/training/Training.typed";
import type { ZekayCustomer } from "../../../../api/customers/Customer.typed";
import ProfileForm from "../../../shared/profileForm/ProfileForm";

interface TrainingItemPanelsProps {
  training: Training;
  setTrainings: React.Dispatch<React.SetStateAction<Training[] | undefined>>;
  refreshTrainingsFromParent?: () => Promise<Training[] | undefined>;
  profileFormOpen: boolean;
  customer: ZekayCustomer | undefined;
  setProfileFormOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setCustomer: React.Dispatch<React.SetStateAction<ZekayCustomer | undefined>>;
  profileEditable?: boolean;
  desync?: boolean;
}

const TrainingItemPanels: React.FC<TrainingItemPanelsProps> = (props) => (
  <>
    {props.profileFormOpen && (
      <ProfileForm
        customer={props.customer}
        setProfileFormOpen={props.setProfileFormOpen}
        setCustomerUpdated={props.setCustomer}
        editable={props.profileEditable}
        desync={props.desync}
      />
    )}
  </>
);

export default React.memo(TrainingItemPanels);
